// extracted by mini-css-extract-plugin
module.exports = {"node":"styles_node__6E956","container":"styles_container__5PcCu","editIcon":"styles_editIcon__gb+4a"};